module.exports = __webpack_public_path__ + "img/2_56.60f66b45.png";